export const PATHROUTES = {
  ROOT: '/',
  STYLE_GUIDE: '/style-guide',

  AUTH: {
    ROLE_SELECTION: '/auth/role-selection',
    RESET_PASSWORD: '/auth/reset-password', // NOSONAR - Route path, not a password
    CREATE_PASSWORD: '/auth/create-password', // NOSONAR - Route path, not a password
    LOGIN: '/auth/login',
    RESET_MESSAGE: '/auth/reset-message',
    PASSWORD_CHANGED: '/auth/password-changed', // NOSONAR - Route path, not a password
  },

  DASHBOARD: {
    ROOT: '/dashboard',
    USERS_MANAGEMENT: '/dashboard/users-management',
    EVENT_MANAGEMENT: '/dashboard/event-management',
    CATEGORY_MANAGEMENT: '/dashboard/category-management',
    SPONSOR_AD_MANAGEMENT: '/dashboard/sponsor-ad-management',
    USER_PROFILE: '/dashboard/user-profile',
    ATTENDEE_MANAGEMENT: '/dashboard/attendee-management',
    SPONSORSHIP_MANAGEMENT: '/dashboard/sponsorship-management',
    SPONSORSHIP_DETAILS: '/dashboard/sponsorship-details',
    SPONSORSHIP_DETAILS_WITH_ID: (id: string) =>
      `/dashboard/sponsorship-details/${id}`,
    SPONSORSHIP_DETAILS_WITH_PARAM: '/dashboard/sponsorship-details/:id',
    SELECT_PACKAGE: '/dashboard/select-package',
    SELECT_PACKAGE_WITH_ID: (id: string) => `/dashboard/select-package/${id}`,
    SELECT_PACKAGE_WITH_PARAM: '/dashboard/select-package/:id',
    UPLOAD_AD: '/dashboard/upload-ad',
    UPLOAD_AD_WITH_ID: (id: string) => `/dashboard/upload-ad/${id}`,
    UPLOAD_AD_WITH_PARAM: '/dashboard/upload-ad/:id',
    MESSAGE_ADMIN: '/dashboard/message-admin',
    MESSAGE_ADMIN_WITH_ID: (id: string) => `/dashboard/message-admin/${id}`,
    MESSAGE_ADMIN_WITH_PARAM: '/dashboard/message-admin/:id',
    DEMOGRAPHICS_DASHBOARD: '/dashboard/demographics-dashboard',
    EVENT_DASHBOARD: '/dashboard/event-dashboard',
    ADD_USER: '/dashboard/add-user',
    ADD_EVENT: '/dashboard/add-event',
    EDIT_EVENT_WITH_ID: (id: string) => `/dashboard/edit-event/${id}`,
    EDIT_EVENT_WITH_PARAM: '/dashboard/edit-event/:id',
    EVENT_DETAILS_WITH_ID: (id: string) => `/dashboard/event-details/${id}`,
    EVENT_DETAILS_WITH_PARAM: '/dashboard/event-details/:eventId',
    EDIT_USER: '/dashboard/edit-user',
    EDIT_USER_WITH_ID: (id: string) => `/dashboard/edit-user/${id}`,
    EDIT_USER_WITH_PARAM: '/dashboard/edit-user/:id',
    ADD_SUB_EVENT_WITH_ID: (id: string) => `/dashboard/add-sub-event/${id}`,
    ADD_SUB_EVENT_WITH_PARAM: '/dashboard/add-sub-event/:mainEventId',
    EDIT_SUB_EVENT_WITH_ID: (id: string) => `/dashboard/edit-sub-event/${id}`,
    EDIT_SUB_EVENT_WITH_PARAM: '/dashboard/edit-sub-event/:id',
    BDTC_MANAGEMENT: '/dashboard/bdtc-management',
  },

  DEFAULT_REDIRECT: '/dashboard/users-management',
  FALLBACK_REDIRECT: '/dashboard/users-management',
} as const

export const ROUTE_PARAMS = {
  USER_ID: ':id',
  EVENT_ID: ':eventId',
} as const

export const routeHelpers = {
  editUser: (id: string) => `/dashboard/edit-user/${id}`,
  editEvent: (id: string) => `/dashboard/edit-event/${id}`,
  userProfile: (id: string) => `/dashboard/user/${id}`,
}
